function makeBendingCheckSummaryRow(label, value) {
    return `<tr><td>${label}</td><td><span style='float:right;'>${value}</span></td></tr>`
}

function showBendingCheckSummary(project) {
    const design = project.design;
    var checks = g_results["bending_checks"];
    var controlling_unity = checks["controlling_unity"];
    var controlling_case = checks["controlling_case"];
    var controlling_Mu = checks["controlling_Mu"];
    var controlling_Mn = checks["controlling_Mn"];
    var controlling_equation = checks["controlling_code_equation"];
    var controlling_case = checks["controlling_case"];
    var controlling_location = checks["controlling_loc"];
    var controlling_Lb = checks["controlling_Lb"];
    
    const nice_eq_index = Number(controlling_case.split('EQ')[1])

    var nice_case = design.loadCombination["prettyEquations"][nice_eq_index-1]["EQ"];
    var success = controlling_unity < 1.0;
    var designStatusStr = success ? '<i class="fa fa-check"></i>' : '<i class="fa fa-remove"></i>';
    configureCardAppearance('bending-design-panel', success)

    let str = `
        <div class="card-header">
            <div class="fs-6">
                ${designStatusStr} Bending
                <span class="float-end">${controlling_unity.toFixed(2)}</span>
            </div>
        </div>`

    str += "<div class='bg-white rounded-2'><table class='table table-borderless'>";

    str += "<tr>";
    if(project.isEngineeredLumber) {
        str += "<td>Mu (Demand)</td>";
    } else if(project.isASD) {
        str += "<td>Ma (Demand)</td>";
    } else {
        str += "<td>Mu (Demand)</td>";
    }
    str += "<td><span style='float:right;'>"+ showBigMoment(controlling_Mu) + " " + bigMomentUnit() + "</span></td></tr>";

    str += "<tr>";
    if(project.isEngineeredLumber) {
        if(project.shape.flitch) {
            str += "<td>Mn + Mn<sub>steel</sub> (Capacity)";
        } else {
            str += "<td>Mn (Capacity)</td>";
        }
    } else if(project.isASD) {
        str += "<td>Mn/&Omega; (Capacity)</td>";
    } else if(project.isNoDesign) {
        str += "<td>Mn (Capacity)</td>";
    } else {
        str += "<td>&Phi; Mn (Capacity)</td>";
    }
    str += "<td><span style='float:right;'>"+ showBigMoment(controlling_Mn) + " " + bigMomentUnit() + "</span></td></tr>";

    if(project.isEngineeredLumber) {
        if(project.shape.flitch) {
            str += "<tr>";
            str += "<td>Mn<sub>steel</sub> (Capacity)";
            str += "<td><span style='float:right;'>0.6 &middot; Fy &middot; Zx</span></td></tr>";
        }
    }

    str += "<tr>";
    str += "<td>Controlling Equation</td>";
    if(project.isEngineeredLumber) {
        if(project.shape.flitch) {
            str += "<td><span style='float:right;'>Mu &le; Mn + Mn<sub>steel</sub>";
        } else {
            str += "<td><span style='float:right;'>Mu &le; Mn";
        }
    } else if(project.isFormTechShape) {
        str += "<td><span style='float:right;'>"+ controlling_equation +"</span></td></tr>";
    } else if(project.isNoDesign) {
        str += "<td><span style='float:right;'>Mn = Fy &bull; Zx";
    } else {
        str += "<td><span style='float:right;'>"+ controlling_equation +"</span></td></tr>";
    }

    str += "<tr>";
    str += "<td>Location</td>";
    str += "<td><span style='float:right;'>"+ showLengthWithUnits(controlling_location) + "</span></td></tr>";

    str += "<tr>";
    str += "<td>Load Combination</td>";
    str += "<td><span style='float:right;'>" + nice_case  +"</span></td></tr>";

    if(project.isEngineeredLumber) {
        str += "<tr>";
        str += "<td>Lb</td>";
        str += "<td><span style='float:right;'>Continuous</span></td></tr>";
    } else if(design.bracingType === 'unbraced' && design.designType !== 'None' ) {
        str += "<tr>";
        str += "<td>Lb - Unbraced</td>";
        str += "<td><span style='float:right;'>Much larger than " + showLengthWithUnits(project.beam.TotalLength()) + "</span></td></tr>";
    } else if(design.bracingType !== 'continuous' && design.designType !== 'None' ) {
        str += "<tr>";
        if(project.isSteelTee) {
            str += "<td>Lb (stem tension asssumed)</td>";
        } else {
            str += "<td>Lb</td>";
        }
        str += "<td><span style='float:right;'>" + showLengthWithUnits(controlling_Lb) + "</span></td></tr>";
    }

    str += "</table></div>";
    document.getElementById('bending-design-panel').innerHTML = str
}
